<template>
  <div class="contentDiv">
    <a :href="phone ? `tel:${phone}` : '#'" class="contact" v-if="!type">
      <van-icon name="service-o" size="16" />
      <span>客服</span>
    </a>
    <!--待支付-->
    <div class="overview" v-if="order.status === 1 || order.status === 5">
      <div class="status" v-if="order.status === 1">等待付款</div>
      <div class="status" v-if="order.status === 5">已取消</div>
      <div class="tips" v-if="order.status === 1">
        <span>应付金额：￥{{ order.needPayPrice }}</span>
        <!--        <span class="countdown">支付剩余23时57分42秒</span>-->
      </div>
      <!-- <div class="button" @click="submit" v-if="order.status === 1">去支付</div> -->
      <div class="button" @click="submit" v-if="order.status === 5">
        再次购买
      </div>
      <!--      <div class="button" v-if="order.status === 4">申请售后</div>-->
      <div class="button" v-if="order.status === 4">去评价</div>
    </div>
    <!--待成团-->
    <div
      class="no-countdown"
      v-if="order.status === 2 && order.groupBuyState === 0"
    >
      <div class="content">
        <div class="status">待成团</div>
        <div class="tips">
          <span>实付金额：￥{{ order.needPayPrice }}</span>
          <!-- <span class="countdown">支付剩余23时57分42秒</span> -->
        </div>
      </div>
      <div class="countdown-box">
        拼团中,还差{{ userNumber }}人， 剩余：
        <div v-if="time.d !== 0">{{ time.d }}天</div>
        <div>{{ time.h > 9 ? time.h : "0" + time.h }}小时</div>
        <div>:</div>
        <div>{{ time.m > 9 ? time.m : "0" + time.m }}分钟</div>
        <div>:</div>
        <div>{{ time.s > 9 ? time.s : "0" + time.s }}秒</div>
      </div>
    </div>

    <!-- 地址 -->
    <div
      class="address-section"
      v-if="order.orderNo && order.orderNo.indexOf('VP') === -1"
    >
      <div class="order-content">
        <span class="yticon icon-shouhuodizhi"></span>
        <div class="cen">
          <div class="top">
            <span class="name">{{ order.consignee }}</span>
            <span class="mobile">{{ order.phone }}</span>
          </div>
          <span class="address">{{ order.address }}</span>
        </div>
        <!-- <span class="yticon icon-you"></span> -->
      </div>
      <van-image
        lazy-load
        class="a-bg"
        src="data:image/png;base64,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"
      ></van-image>
    </div>

    <div class="goods-section">
      <div class="g-header b-b"></div>
      <!-- 商品列表 -->
      <div class="g-list">
        <div
          class="g-item"
          v-for="(item, index) in order.orderItems"
          :key="index"
          @click="navToDetailPage(item)"
        >
          <div class="g-item-info">
            <van-image
              lazy-load
              class="g-item-image"
              width="90"
              height="90"
              :src="item.productPic"
            ></van-image>
            <div
              class="right"
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <span class="title clamp">{{ item.productName }}</span>
              <span class="spec">{{ item.productSpec }}</span>
              <div v-if="item.freightType && item.freightType === 4" style="font-size:12px">
                运费：到付
              </div>
              <div class="price-box">
                <div>
                  <span class="price">¥{{ item.price }}</span>
                  <span class="number">x {{ item.quantity }}</span>
                </div>
                <div
                  class="refund-box"
                  v-if="
                    (order.status !== 4 && order.status !== 5) ||
                    item.status !== 1
                  "
                >
                  <span
                    class="refund-btn"
                    @click.stop="confirmRefund(item)"
                    v-if="
                      (item.status === 1 &&
                        order.status !== 1 &&
                        order.groupBuyState !== 0) ||
                      item.status === 2
                    "
                    >申请退款</span
                  >
                  <span
                    v-if="item.status === 2"
                    class="refund-btn"
                    @click.stop="confirmReceipt(item.id)"
                    >确认收货</span
                  >
                  <span
                    v-if="item.status === 2"
                    class="refund-btn"
                    @click.stop="ViewLogistics(item)"
                    >查看物流</span
                  >
                  <span
                    v-if="item.status === 3"
                    class="refund-btn"
                    @click.stop="CancelRefund(item.id)"
                    >取消退款</span
                  >
                  <!--              <span v-if="item.status===4" class="refund-btn">去购买</span>-->
                  <span v-if="item.status === 5">交易完成</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="g-item-qrcode"
            @click.stop="qrCodeClick(item.qrCode)"
            v-if="
              item.status === 1 &&
              order.groupBuyState !== 0 &&
              type == 'virtual'
            "
          >
            <span class="qrcode-text">核销码</span>
            <div class="qrcode-img-box">
              <van-image
                v-if="item.qrCode"
                lazy-load
                class="qrcode-img"
                width="40"
                height="40"
                :src="item.qrCode"
              ></van-image>
            </div>
          </div>
          <div class="g-item-qrcode" v-if="item.offStartTime">
            <span class="qrcode-text"
              >订单有效时间: {{ item.offStartTime }}-{{ item.offEndTime }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 优惠明细 -->
    <!-- <div class="yt-list">
			<div class="yt-list-cell b-b" @click="toggleMask('show')">
				<div class="cell-icon">
					券
				</div>
				<span class="cell-tit clamp">优惠券</span>
				<span class="cell-tip active">
					选择优惠券
				</span>
				<span class="cell-more wanjia wanjia-gengduo-d"></span>
			</div>
			<div class="yt-list-cell b-b">
				<div class="cell-icon hb">
					减
				</div>
				<span class="cell-tit clamp">商家促销</span>
				<span class="cell-tip disabled">暂无可用优惠</span>
			</div>
    </div>-->

    <!-- 金额明细 -->
    <div class="yt-list">
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">商品金额</span>
        <span class="cell-tip">￥{{ order.totalPrice }}</span>
      </div>
      <div class="yt-list-cell b-b" v-if="!type">
        <span class="cell-tit clamp">运费</span>
        <span class="cell-tip"
          >¥{{ order.freight > 0 ? order.freight : "免运费" }}</span
        >
      </div>

      <div class="yt-list-cell b-b" v-if="order.consignee">
        <span class="cell-tit clamp">联系人</span>
        <span class="cell-tip">{{ order.consignee }}</span>
      </div>
      <div class="yt-list-cell b-b" v-if="order.phone">
        <span class="cell-tit clamp">联系人电话</span>
        <span class="cell-tip">{{ order.phone }}</span>
      </div>
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">买家留言</span>
        <span class="cell-tip">{{ order.remark }}</span>
      </div>
    </div>

    <!-- 金额明细 -->
    <div class="yt-list">
      <div v-if="order.discount > 0" class="yt-list-cell b-b">
        <span class="cell-tit clamp">会员折扣</span>
        <span class="cell-tip">-¥{{ order.discount }}</span>
      </div>
      <div v-if="order.pointDeductPrice > 0" class="yt-list-cell b-b">
        <span class="cell-tit clamp">积分抵扣</span>
        <span class="cell-tip">-￥{{ order.pointDeductPrice }}</span>
      </div>
      <div v-if="order.coupon > 0" class="yt-list-cell b-b">
        <span class="cell-tit clamp">优惠券</span>
        <span class="cell-tip">-￥{{ order.coupon }}</span>
      </div>
      <div v-if="order.shoppingCard > 0" class="yt-list-cell b-b">
        <span class="cell-tit clamp">购物卡</span>
        <span class="cell-tip">-￥{{ order.shoppingCard }}</span>
      </div>
    </div>

    <!-- 订单明细 -->
    <div class="yt-list">
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">订单编号</span>
        <span class="cell-tip">{{ order.orderNo }}</span>
      </div>
      <div v-if="order.createTime" class="yt-list-cell b-b">
        <span class="cell-tit clamp">下单日期</span>
        <span class="cell-tip">{{ order.createTime }}</span>
      </div>
      <div v-if="order.payTime" class="yt-list-cell b-b">
        <span class="cell-tit clamp">付款日期</span>
        <span class="cell-tip">{{ order.payTime }}</span>
      </div>
      <div v-if="order.deliveryTime" class="yt-list-cell b-b">
        <span class="cell-tit clamp">发货日期</span>
        <span class="cell-tip">{{ order.deliveryTime }}</span>
      </div>
      <div v-if="order.receiptTime" class="yt-list-cell b-b">
        <span class="cell-tit clamp">收货日期</span>
        <span class="cell-tip">{{ order.receiptTime }}</span>
      </div>
      <div v-if="order.finishedTime" class="yt-list-cell b-b">
        <span class="cell-tit clamp">完成时间</span>
        <span class="cell-tip">{{ order.finishedTime }}</span>
      </div>
      <div v-if="order.needPayPrice" class="yt-list-cell b-b">
        <span class="cell-tit clamp">实付款</span>
        <span class="cell-tip" style="color: #fa436a"
          >￥{{ order.needPayPrice }}</span
        >
      </div>
      <div v-if="order.usePoint > 0" class="yt-list-cell b-b">
        <span class="cell-tit clamp">抵扣积分</span>
        <span class="cell-tip">{{ order.usePoint }}个</span>
      </div>
    </div>

    <div class="yt-list">
      <div
        v-if="order.groupBuyState != null && order.groupBuyState != undefined"
        class="yt-list-cell b-b"
      >
        <span class="clamp fs-14 themeFontColor">{{
          order.groupBuyState == 0
            ? "拼购中"
            : order.groupBuyState == 1
            ? "拼购成功"
            : "拼购失败"
        }}</span>
      </div>
      <div
        v-if="order.groupBuyState != null && order.groupBuyState != undefined"
        class="yt-list-cell b-b d-flex flex-row align-items-center"
      >
        <div
          class="d-flex flex-row align-items-center rounded-circle"
          :style="{
            height: '50px',
            width: '50px',
            left: cIndex * 20 + 'px',
            border: '2px white solid',
          }"
          v-for="(cItem, cIndex) in order.groupBuy"
          :key="cIndex"
        >
          <van-image
            lazy-load
            round
            width="45"
            height="45"
            :src="cItem && cItem.memberAvatar ? cItem.memberAvatar : ''"
          />
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer" v-if="order.status !== 2">
      <div class="price-content">
        <!--        <div class="d-flex flex-row align-items-center">-->
        <!--          <span>实付款</span>-->
        <!--          <span class="price-tip">￥</span>-->
        <!--          <span class="price">{{order.needPayPrice}}</span>-->
        <!--        </div>-->
      </div>
      <template v-if="order.status === 1">
        <span class="cancel" @click="orderCancel">取消订单</span>
        <span class="submit" @click="submit">确认支付</span>
      </template>
      <template v-if="order.status === 4">
        <span class="cancel" @click="deleteOrder">删除订单</span>
        <!-- <span
          v-if="
            (order.commentStatus && order.commentStatus == 1) ||
            order.commentStatus == 1
          "
          class="submit"
          @click="appraise"
          >查看评价</span
        >
        <span v-else class="submit" @click="appraise">去评价</span> -->
      </template>
      <template v-if="order.status === 5">
        <span class="cancel" @click="deleteOrder">删除订单</span>
        <span class="submit" @click="submit">再次购买</span>
      </template>

      <!--      <span v-if="order.status === 3" class="submit" @click="appraise">查看物流</span>-->
    </div>
    <div class="footer" v-if="order.groupBuyState === 0 && order.status === 2">
      <span class="share" @click="share">邀请好友</span>
    </div>

    <!-- 优惠券面板 -->
    <!-- <div class="mask" :class="maskState===0 ? 'none' : maskState===1 ? 'show' : ''" @click="toggleMask">
			<div class="mask-content" @click.stop.prevent="stopPrevent">

				<div class="coupon-item" v-for="(item,index) in couponList" :key="index">
					<div class="con">
						<div class="left">
							<span class="title">{{item.title}}</span>
							<span class="time">有效期至2019-06-30</span>
						</div>
						<div class="right">
							<span class="price">{{item.price}}</span>
							<span>满30可用</span>
						</div>

						<div class="circle l"></div>
						<div class="circle r"></div>
					</div>
					<span class="tips">限新用户使用</span>
				</div>
			</div>
    </div>-->
    <van-popup
      v-model="showDialog"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-notice-bar
        v-if="productStatus === 2"
        left-icon="volume-o"
        text="该商品已发货，需要将商品退回。"
      />
      <van-field
        v-model="message"
        rows="4"
        label="退款原因:"
        type="textarea"
        placeholder="请输入退款原因"
        :border="false"
      />
      <div class="btns">
        <van-button class="cancelBtn" @click="close">取消</van-button>
        <van-button class="okBtn" type="info" @click="btnOk">确认</van-button>
      </div>
    </van-popup>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper">
        <div class="block">点击右上角···,可以分享给好友</div>
      </div>
    </van-overlay>
    <van-popup v-model="showQc">
      <!-- 二维码 -->
      <van-image
        lazy-load
        class="qrcode-img"
        width="200"
        height="200"
        :src="qrCodeUrl"
      ></van-image>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { mapState } from "vuex";
export default {
  data() {
    return {
      qrCodeUrl: "",
      showQc: false,
      showOverlay: false,
      orderId: null,
      order: {},
      showDialog: false,
      message: "",
      productId: "",
      phone: "",
      time: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
      },
      type: "",
      productStatus: "",
    };
  },
  computed: {
    ...mapState(["domain"]),
    userNumber() {
      let arr = this.order.groupBuy.filter((item) => {
        return item && item.memberAvatar;
      });
      let num = this.order.maxMemberCount - arr.length;
      return num;
    },
  },
  created(option) {
    let query = this.$route.query;
    this.orderId = query.orderId * 1;
    this.type = query.type;
    this.loadData();
    this.getPhone();
  },
  methods: {
    qrCodeClick(url) {
      this.qrCodeUrl = url;
      this.showQc = true;
    },
    getPhone() {
      this.$http.request(this.$http.pathMap.getPhone, "get").then((res) => {
        this.phone = res.data;
      });
    },
    btnOk() {
      let params = {
        itemIds: [],
        orderId: this.orderId,
        refundRemark: this.message,
      };
      if (this.productId) {
        params.itemIds.push(this.productId);
      } else {
        params.itemIds;
      }
      if (!this.message) return this.$toast("不能为空");
      this.$http
        .request(this.$http.pathMap.orderRefund, "post", params)
        .then(() => {
          this.loadData();
          this.message = "";
          this.showDialog = false;
        });
      this.$toast("申请成功");
    },
    close() {
      this.message = "";
      this.showDialog = false;
    },
    loadData() {
      this.getOrder();
    },
    getOrder() {
      let url = this.$http.pathMap.orderInfo + this.orderId;
      this.$http.request(url, "get").then((res) => {
        this.order = res.data.order;
        if (this.order.groupBuyState === 0) {
          this.order.groupBuy.length = this.order.maxMemberCount;
          this.startInterval2();
        }
      });
    },
    submit() {
      this.$router.replace({
        path: "/pages/money/pay",
        query: {
          orderNo: this.order.orderNo,
        },
      });
    },
    confirmRefund(item) {
      this.showDialog = true;
      this.productId = item.id;
      this.productStatus = item.status;
    },
    async CancelRefund(id) {
      let params = {
        itemIds: [],
        orderId: this.orderId,
      };
      if (id) {
        params.itemIds.push(id);
      } else {
        params.itemIds;
      }
      try {
        await Dialog.confirm({
          message: "确认取消吗？",
        });
        await this.$http.request(
          this.$http.pathMap.CancelRefund,
          "post",
          params
        );
        this.loadData();
      } catch {}
    },
    async confirmReceipt(id) {
      let params = {
        itemIds: [],
        orderId: this.orderId,
      };
      if (id) {
        params.itemIds.push(id);
      } else {
        params.itemIds;
      }
      await this.$http.request(
        this.$http.pathMap.confirmReceipt,
        "post",
        params
      );
      this.loadData();
    },
    async orderCancel() {
      await this.$http.request(
        this.$http.pathMap.orderCancel + "/" + this.orderId,
        "get"
      );
      this.$toast("取消订单成功");
      this.$router.back();
    },
    async deleteOrder() {
      await this.$http.request(
        this.$http.pathMap.orderDeleted + "/" + this.orderId,
        "get"
      );
      this.$toast("删除订单成功");
      this.$router.back();
    },
    appraise() {
      this.$router.push({
        path: "/pages/appraise/index",
        query: {
          orderId: this.orderId,
        },
      });
    },
    ViewLogistics(item) {
      this.$router.push({
        path: "/pages/order/logistics",
        query: {
          id: item.id,
          deliveryName: item.deliveryName,
          deliveryNum: item.deliveryNum,
        },
      });
    },
    navToDetailPage(item) {
      let id = item.productId;
      let type = 1;
      if (this.type === "virtual") {
        type = 3;
      }
      this.$router.push({
        path: "/pages/product/product",
        query: {
          id,
          type,
        },
      });
    },
    // 获取当前时间
    getNowTime() {
      const yy = new Date().getFullYear();
      const MM =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      const dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      const HH =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      const mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      const ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      return yy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss;
    },
    //定时器
    startInterval2() {
      //总倒计时
      this.serverTime = new Date(
        this.getNowTime().replace(/-/g, "/")
      ).getTime();
      this.groupEndTime = new Date(
        this.order.dueTime.replace(/-/g, "/")
      ).getTime();
      let that = this;
      that.timeIn = setInterval(() => {
        that.serverTime += 500;
        let time = that.computeTime(this.serverTime, this.groupEndTime);
        if (time) {
          this.time = time;
        } else {
          // clearInterval(that.timeIn)
          // this.getProduct()
        }
      }, 500);
    },
    computeTime(startTime, endTime) {
      if (startTime >= endTime) {
        return false;
      }
      let SS = Math.floor(endTime - startTime) / 1000;
      let d = parseInt(SS / (3600 * 24));
      let h = parseInt((SS - d * 3600 * 24) / 3600);
      let m = parseInt((SS - d * 3600 * 24 - h * 3600) / 60);
      let s = parseInt(SS - d * 3600 * 24 - h * 3600 - m * 60);
      return {
        d,
        h,
        m,
        s,
      };
    },
    share() {
      this.showOverlay = true;
      let that = this;
      that.$http.getJsSdkConfig().then((res) => {
        that.updateShare();
      });
    },
    updateShare() {
      let href = `${this.domain}#/pages/product/product?id=${this.order.orderItems[0].productId}&g=${this.order.groupBuyGroupId}`;
      let title = `【仅剩${this.userNumber}个名额】${this.order.orderItems[0].productName}`;
      let desc = `我买了【${this.order.orderItems[0].productSpec}】`;
      let imgUrl = this.order.orderItems[0].productPic;
      let share = {
        title, // 分享标题
        desc, // 分享描述
        link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
      };
      ///朋友和QQ
      window.wx.updateAppMessageShareData({
        ...share,
      });
      ///朋友圈和空间
      window.wx.updateTimelineShareData({
        ...share,
      });
      ///微博
      window.wx.onMenuShareWeibo({
        ...share,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.van-overlay {
  z-index: 99999;
}
.wrapper {
  display: flex;

  justify-content: center;
  height: 100%;
  .block {
    margin-top: 100px;
    color: #fff;
    height: 120px;
    font-size: 18px;
  }
}
.van-popup {
  padding: 15px;
  .btns {
    width: 100%;
    position: absolute;
    bottom: 20px;
    display: flex;
    justify-content: space-around;
    .cancelBtn {
      width: 100px;
    }
    .okBtn {
      width: 100px;
    }
  }
}
.contentDiv {
  padding-bottom: 45px;
  .contact {
    position: fixed;
    z-index: 999;
    bottom: 70px;
    right: 20px;
    display: inline-block;
    text-decoration: none;
    color: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 100%;
    background: #fff;
    width: 40px;
    height: 40px;
    border: 1px solid #ccc;
    span {
      font-size: 12px;
    }
  }
  .overview {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1;
    padding: 15px 0;
    color: #fff;
    background: $base-color;

    .status {
      font-size: 18px;
    }
    .tips {
      margin-top: 15px;
      font-size: 12px;
      .countdown {
        margin-left: 5px;
      }
    }
    .button {
      width: 130px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      margin-top: 15px;
      font-size: 14px;
      color: $base-color;
      border-radius: 34px;
      background: #fff;
    }
  }
  .no-countdown {
    line-height: 1;
    height: 100px;
    color: #fff;
    background: $base-color;
    position: relative;
    .content {
      position: absolute;
      top: 40px;
      left: 10px;
      .status {
        font-size: 18px;
      }
      .tips {
        margin-top: 5px;
        font-size: 12px;
      }
    }
    .countdown-box {
      display: flex;
      position: absolute;
      top: 10px;
      left: 0;
      padding: 2px 5px;
      background: rgba(0, 0, 0, 0.4);
      font-size: 12px;
    }
  }
}
.address-section {
  padding: 15px 0;
  background: #fff;
  position: relative;

  .order-content {
    display: flex;
    align-items: center;
  }

  .icon-shouhuodizhi {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    color: #888;
    font-size: 22px;
  }

  .cen {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 14px;
    color: $font-color-dark;
  }

  .name {
    font-size: 17px;
    margin-right: 12px;
  }

  .address {
    margin-top: 8px;
    margin-right: 10px;
    color: $font-color-light;
  }

  .icon-you {
    font-size: 16px;
    color: $font-color-light;
    margin-right: 15px;
  }

  .a-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 2px;
  }
}

.goods-section {
  margin-top: 15px;
  background: #fff;
  padding-bottom: 1px;

  .g-header {
    display: flex;
    align-items: center;
    height: 0;
    padding: 0 15px;
    position: relative;
  }

  .logo {
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 100px;
  }

  .name {
    font-size: 15px;
    color: $font-color-base;
    margin-left: 12px;
  }

  .g-item {
    margin: 10px 15px;
    .g-item-info {
      display: flex;
    }
    .g-item-qrcode {
      border-top: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      padding-top: 10px;
      .qrcode-text {
        font-size: 14px;
      }
    }

    .g-item-image {
      flex-shrink: 0;
      display: block;
      width: 70px;
      height: 70px;
      border-radius: 2px;
    }

    .right {
      flex: 1;
      padding-left: 12px;
      overflow: hidden;
    }
    .refund-box {
      display: flex;

      .refund-btn {
        margin-left: 10px;
        font-size: 12px;
        padding: 5px;
        background: var(--theme-font-color);
        font-size: $uni-font-size-base;
        color: #fff;
      }
    }
    .title {
      font-size: 15px;
      color: $font-color-dark;
    }

    .spec {
      font-size: 13px;
      color: $font-color-light;
    }

    .price-box {
      display: flex;
      align-items: center;
      font-size: 16px;
      justify-content: space-between;
      color: $font-color-dark;
      padding-top: 5px;

      .price {
        margin-bottom: 2px;
      }

      .number {
        font-size: 13px;
        color: $font-color-base;
        margin-left: 10px;
      }
    }

    .step-box {
      position: relative;
    }
  }
}

.yt-list {
  margin-top: 8px;
  background: #fff;
}

.yt-list-cell {
  display: flex;
  align-items: center;
  padding: 5px 15px 5px 20px;
  line-height: 35px;
  position: relative;

  &.cell-hover {
    background: #fafafa;
  }

  &.b-b:after {
    left: 15px;
  }

  .cell-icon {
    height: 16px;
    width: 16px;
    font-size: 11px;
    color: #fff;
    text-align: center;
    line-height: 16px;
    background: #f85e52;
    border-radius: 2px;
    margin-right: 6px;

    &.hb {
      background: #ffaa0e;
    }

    &.lpk {
      background: #3ab54a;
    }
  }

  .cell-more {
    align-self: center;
    font-size: 12px;
    color: $font-color-light;
    margin-left: 4px;
    margin-right: -5px;
  }

  .cell-tit {
    flex: 1;
    font-size: 13px;
    color: $font-color-light;
    margin-right: 5px;
  }

  .cell-tip {
    font-size: 13px;
    color: $font-color-dark;

    &.disabled {
      color: $font-color-light;
    }

    &.active {
      color: $base-color;
    }

    &.red {
      color: $base-color;
    }
  }

  &.desc-cell {
    .cell-tit {
      max-width: 45px;
    }
  }

  .desc {
    flex: 1;
    font-size: $uni-font-size-base;
    color: $font-color-dark;
  }
}

/* 支付列表 */
.pay-list {
  padding-left: 20px;
  margin-top: 8px;
  background: #fff;

  .pay-item {
    display: flex;
    align-items: center;
    padding-right: 10px;
    line-height: 1;
    height: 55px;
    position: relative;
  }

  .icon-weixinzhifu {
    width: 40px;
    font-size: 20px;
    color: #6bcc03;
  }

  .icon-alipay {
    width: 40px;
    font-size: 20px;
    color: #06b4fd;
  }

  .icon-xuanzhong2 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 30px;
    color: $base-color;
  }

  .tit {
    font-size: 16px;
    color: $font-color-dark;
    flex: 1;
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
  justify-content: end;
  font-size: 15px;
  background-color: #fff;
  z-index: 998;
  color: $font-color-base;
  box-sizing: border-box;
  .share {
    color: #fff;
    padding: 5px;
    background: #f85e52;
    margin-right: 10px;
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .price-content {
    padding-left: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .price-tip {
    color: $base-color;
    margin-left: 4px;
  }

  .price {
    font-size: 18px;
    color: $base-color;
  }

  .submit {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 100%;
    color: #fff;
    font-size: 16px;
    background-color: $base-color;
    box-sizing: border-box;
  }
  .cancel {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 100%;
    font-size: 16px;
    box-sizing: border-box;
  }
}

/* 优惠券面板 */
.mask {
  display: flex;
  align-items: flex-end;
  position: fixed;
  left: 0;
  top: var(--window-top);
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 9995;
  transition: 0.3s;

  .mask-content {
    width: 100%;
    min-height: 30vh;
    max-height: 70vh;
    background: #f3f3f3;
    transform: translateY(100%);
    transition: 0.3s;
    overflow-y: scroll;
  }

  &.none {
    display: none;
  }

  &.show {
    background: rgba(0, 0, 0, 0.4);

    .mask-content {
      transform: translateY(0);
    }
  }
}

/* 优惠券列表 */
.coupon-item {
  display: flex;
  flex-direction: column;
  margin: 10px 12px;
  background: #fff;

  .con {
    display: flex;
    align-items: center;
    position: relative;
    height: 60px;
    padding: 0 15px;

    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px dashed #f3f3f3;
      transform: scaleY(0.5);
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    overflow: hidden;
    height: 50px;
  }

  .title {
    font-size: 16px;
    color: $font-color-dark;
    margin-bottom: 5px;
  }

  .time {
    font-size: 12px;
    color: $font-color-light;
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: $font-color-base;
    height: 50px;
  }

  .price {
    font-size: 22px;
    color: $base-color;

    &:before {
      content: "￥";
      font-size: 17px;
    }
  }

  .tips {
    font-size: 12px;
    color: $font-color-light;
    line-height: 30px;
    padding-left: 15px;
  }

  .circle {
    position: absolute;
    left: -3px;
    bottom: -5px;
    z-index: 10;
    width: 10px;
    height: 10px;
    background: #f3f3f3;
    border-radius: 100px;

    &.r {
      left: auto;
      right: -3px;
    }
  }
}
</style>
